import { Component, inject } from '@angular/core';
import { BaryComponentHelper } from '../../../shared/util/bary-component-helper';
import { BaryModalEvent, IBaryModalEvent } from '../../../../models/bary-modal-event';
import { BasketOrderView } from '../../../../models/basket-order-view.model';
import { TranslateService } from '@ngx-translate/core';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryModalService } from '../../../../services/bary-modal.service';
import { PaymentMethodEnum } from '../../../../models/enums/payment-method.enum';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-modal-customer-notification-differed-payment',
  templateUrl: './modal-customer-notification-differed-payment.component.html',
  styleUrls: ['./modal-customer-notification-differed-payment.component.scss'],
})
export class ModalCustomerNotificationDifferedPaymentComponent {
  private readonly modalRef = inject(MDBModalRef);
  private readonly translate = inject(TranslateService);
  private readonly modalService = inject(BaryModalService);

  public action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public basketOrderList?: BasketOrderView[];

  protected readonly FAS = FaDirectiveEnum.FAS;

  public handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  public goToPaymentForm(basketOrder: BasketOrderView): void {
    const message = this.translate.instant('modals.differedPayment.text', { priceTTC: basketOrder.price });
    this.modalService.openConfirmPayment(message, { idBasketOrder: basketOrder.id }, PaymentMethodEnum.INIT_TRANSFERT_DEFERRED, false).action().subscribe();
  }
}
